import React, { useState, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Col,
  Input,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import moment from "moment";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";

function SeguimientoNotas() {
  const { user } = useContext(AuthContext);
  const URL_PEDIDOS = process.env.REACT_APP_URL_PEDIDOS;
  const URL_ARTICULOS_PEDIDO = process.env.REACT_APP_URL_ARTICULOS_PEDIDO;

  const hoy = new Date();
  const inicio = new Date();
  inicio.setDate(inicio.getDate() - 120);
  const endDate = moment(hoy).format("YYYY-MM-DD");
  const startDate = moment(inicio).format("YYYY-MM-DD");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [soloConNotas, setSoloConNotas] = useState("Si");
  const [vista, setVista] = useState("lista"); // "lista" | "calendario"
  const [fechaCal, setFechaCal] = useState(new Date());

  // Modal para agregar/ver notas (mismo patrón que ListadoPedidos)
  const [modalNota, setModalNota] = useState(false);
  const toggleNota = () => setModalNota(!modalNota);
  const [notaPedidoId, setNotaPedidoId] = useState("");
  const [notaNumeroPedido, setNotaNumeroPedido] = useState("");
  const [notasList, setNotasList] = useState([]);
  const [nuevaNotaTexto, setNuevaNotaTexto] = useState("");
  const [nuevaNotaFecha, setNuevaNotaFecha] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  // Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  useMemo(() => {
    axios
      .get(`${URL_PEDIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allPedidos = response.data;

        // Solo cotizaciones ABIERTAS y activas
        allPedidos = allPedidos.filter(
          (p) => p.is_active === "Si" && p.status === "Abierto"
        );

        // Filtro por vendedor: si el usuario es vendedor solo ve sus propios pedidos
        if (user.vendedor === "Si") {
          allPedidos = allPedidos.filter(
            (p) => p.colaboradores?.[0]?.email === user.email
          );
        }

        const arrayTabla = allPedidos
          .sort((a, b) => (a.idPedido < b.idPedido ? 1 : -1))
          .map((a) => {
            const notas = Array.isArray(a.notas) ? a.notas : [];
            const notasOrdenadas = notas
              .slice()
              .sort((x, y) => (x.fecha < y.fecha ? 1 : -1));
            const ultimaNota = notasOrdenadas[0] || null;
            return {
              _id: a._id,
              numero: a.idPedido,
              activo: a.is_active,
              status: a.status,
              fecha: a.fecha,
              clientes: a.clientes?.[0]?.nombre_comercial || "",
              idClientes: a.clientes?.[0]?._id || "",
              codigoClientes: a.clientes?.[0]?.codigo || "",
              vendedor:
                `${a.colaboradores?.[0]?.nombre || ""} ${
                  a.colaboradores?.[0]?.apellido || ""
                }`.trim(),
              idVendedor: a.colaboradores?.[0]?._id || "",
              total_general: a.total_general,
              total_cantidad: a.total_cantidad,
              subTotal: a.subTotal,
              iva: a.iva,
              observaciones: a.observaciones,
              descuento: a.descuento,
              comisionTDC: a.comisionTDC,
              comisionFlete: a.comisionFlete,
              comisionInstalacion: a.comisionInstalacion,
              paqueteria: a.paqueteria,
              notas,
              ultimaFechaNota: ultimaNota ? ultimaNota.fecha : "",
              ultimoTextoNota: ultimaNota ? ultimaNota.texto : "",
              ultimoUsuarioNota: ultimaNota ? ultimaNota.userName : "",
              cantidadNotas: notas.length,
              calle: a.clientes?.[0]?.calle || "",
              RFC: a.clientes?.[0]?.RFC || "",
              telefono: a.clientes?.[0]?.telefono || "",
            };
          })
          .filter((el) => el != null);

        setComments(arrayTabla);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]);

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha Cotización", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    { name: "Total", field: "total_general", sortable: true },
    { name: "Últ. Fecha Nota", field: "ultimaFechaNota", sortable: true },
    { name: "Últ. Detalle Nota", field: "ultimoTextoNota", sortable: false },
    { name: "Acciones", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computed = comments;
    if (search) {
      const s = search.toLowerCase();
      computed = computed.filter(
        (c) =>
          c.clientes.toLowerCase().includes(s) ||
          c.vendedor.toLowerCase().includes(s) ||
          String(c.numero).includes(s) ||
          (c.ultimoTextoNota || "").toLowerCase().includes(s) ||
          (c.ultimoUsuarioNota || "").toLowerCase().includes(s)
      );
    }
    if (soloConNotas === "Si") {
      computed = computed.filter((c) => c.cantidadNotas > 0);
    } else if (soloConNotas === "No") {
      computed = computed.filter((c) => c.cantidadNotas === 0);
    }

    setTotalItems(computed.length);

    if (sorting.field) {
      const numericos = ["numero", "total_general", "cantidadNotas"];
      const isNum = numericos.includes(sorting.field);
      const reversed = sorting.order === "asc" ? 1 : -1;
      computed = [...computed].sort((a, b) => {
        const av = a[sorting.field] ?? "";
        const bv = b[sorting.field] ?? "";
        if (isNum) {
          return reversed * (parseFloat(av) - parseFloat(bv));
        }
        return reversed * String(av).localeCompare(String(bv));
      });
    }

    return computed.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [comments, currentPage, search, sorting, soloConNotas]);

  function abrirModalNota(p) {
    setNotaPedidoId(p._id);
    setNotaNumeroPedido(p.numero);
    setNotasList(Array.isArray(p.notas) ? p.notas : []);
    setNuevaNotaTexto("");
    setNuevaNotaFecha(moment(new Date()).format("YYYY-MM-DD"));
    toggleNota();
  }

  function agregarNota() {
    const texto = (nuevaNotaTexto || "").trim();
    if (!texto) {
      Swal.fire({ icon: "warning", title: "Vacío", text: "Escribe el texto de la nota." });
      return;
    }
    if (!nuevaNotaFecha) {
      Swal.fire({ icon: "warning", title: "Fecha", text: "Selecciona la fecha de la nota." });
      return;
    }
    const userName =
      `${user?.nombre || ""} ${user?.apellido || ""}`.trim() ||
      user?.email ||
      "Usuario";
    const nuevaNota = {
      texto,
      fecha: nuevaNotaFecha,
      userName,
      userId: user?.id,
    };
    const nuevasNotas = [...notasList, nuevaNota];

    axios
      .patch(
        `${URL_PEDIDOS}/${notaPedidoId}`,
        { notas: nuevasNotas },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        setNotasList(nuevasNotas);
        setNuevaNotaTexto("");
        setNuevaNotaFecha(moment(new Date()).format("YYYY-MM-DD"));
        // Actualiza la fila en el listado con la nueva última nota
        setComments((prev) =>
          prev.map((c) => {
            if (c._id !== notaPedidoId) return c;
            const notasOrdenadas = nuevasNotas
              .slice()
              .sort((x, y) => (x.fecha < y.fecha ? 1 : -1));
            const ultima = notasOrdenadas[0];
            return {
              ...c,
              notas: nuevasNotas,
              ultimaFechaNota: ultima.fecha,
              ultimoTextoNota: ultima.texto,
              ultimoUsuarioNota: ultima.userName,
              cantidadNotas: nuevasNotas.length,
            };
          })
        );
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Nota agregada",
          showConfirmButton: false,
          timer: 1000,
        });
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se pudo guardar la nota",
          footer: `${error?.response?.data?.message || error?.message || ""}`,
        });
        console.log(error);
      });
  }

  async function descargarPDF(p) {
    // Carga los artículos del pedido para armar la cotización
    try {
      const resArts = await axios.get(
        `${URL_ARTICULOS_PEDIDO}/pedidos/${p._id}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      );
      const arts = (resArts.data || []).filter(
        (a) => a.is_active === "Si" || a.is_active === undefined
      );

      const doc = new jsPDF();
      const img = new Image();
      img.src = process.env.PUBLIC_URL + "logoInstitucion.png";
      try {
        doc.addImage(img, "png", 10, 8, 30, 20);
      } catch (e) {
        /* si no carga, no bloquea */
      }

      // Título y datos del pedido
      doc.setFontSize(14);
      doc.setFont("helvetica", "bold");
      doc.text(`Seguimiento de Cotización #${p.numero}`, 50, 15);
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");
      doc.text(`Fecha: ${p.fecha}`, 50, 22);
      doc.text(`Cliente: ${p.clientes} (${p.codigoClientes})`, 50, 27);
      doc.text(`Vendedor: ${p.vendedor}`, 50, 32);
      doc.text(`Status: ${p.status}`, 50, 37);
      doc.text(
        `Total: ${new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
          maximumFractionDigits: 2,
        }).format(p.total_general || 0)}`,
        50,
        42
      );

      // Tabla de artículos
      const dataArts = arts.map((a) => {
        const nombre =
          `${a.articulos?.[0]?.codigo || ""} ${a.articulos?.[0]?.nombre || ""}`.trim();
        return [
          nombre,
          new Intl.NumberFormat("en-US").format(a.cantidad || 0),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.precio || 0),
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(a.total || 0),
        ];
      });

      doc.autoTable({
        head: [["Producto", "Cantidad", "Precio", "Importe"]],
        body: dataArts,
        startY: 50,
        headStyles: { fillColor: ["#00313c"] },
        theme: "grid",
        styles: { fontSize: 8 },
      });

      // Tabla de notas
      let nextY = doc.autoTable.previous.finalY + 8;
      doc.setFont("helvetica", "bold");
      doc.setFontSize(11);
      doc.text("Historial de Notas", 10, nextY);
      nextY += 4;
      const dataNotas = p.notas
        .slice()
        .sort((a, b) => (a.fecha < b.fecha ? 1 : -1))
        .map((n) => [n.fecha, n.userName || "", n.texto || ""]);
      if (dataNotas.length > 0) {
        doc.autoTable({
          head: [["Fecha", "Usuario", "Nota"]],
          body: dataNotas,
          startY: nextY,
          headStyles: { fillColor: ["#00313c"] },
          theme: "grid",
          styles: { fontSize: 8, cellWidth: "wrap" },
          columnStyles: {
            0: { cellWidth: 25 },
            1: { cellWidth: 40 },
            2: { cellWidth: "auto" },
          },
        });
      } else {
        doc.setFont("helvetica", "normal");
        doc.setFontSize(9);
        doc.text("Sin notas capturadas.", 10, nextY + 5);
      }

      doc.save(`Seguimiento-Cotizacion-${p.numero}-${p.clientes}.pdf`);
    } catch (err) {
      console.log(err);
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No se pudo generar el PDF",
      });
    }
  }

  // Mapa { "YYYY-MM-DD": [{ pedido, nota }, ...] } con TODAS las notas del rango
  const notasPorFecha = useMemo(() => {
    const map = {};
    comments.forEach((p) => {
      (p.notas || []).forEach((n) => {
        if (!n.fecha) return;
        if (!map[n.fecha]) map[n.fecha] = [];
        map[n.fecha].push({ pedido: p, nota: n });
      });
    });
    return map;
  }, [comments]);

  const fechaCalStr = moment(fechaCal).format("YYYY-MM-DD");
  const notasDelDia = notasPorFecha[fechaCalStr] || [];

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_pedidos ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>{" "}
              <Button
                size="sm"
                color={vista === "lista" ? "info" : "secondary"}
                onClick={() => setVista("lista")}
              >
                <i className="fas fa-list"></i> Lista
              </Button>{" "}
              <Button
                size="sm"
                color={vista === "calendario" ? "info" : "secondary"}
                onClick={() => setVista("calendario")}
              >
                <i className="far fa-calendar-alt"></i> Calendario
              </Button>
            </Col>
          </Row>
          <h3 align="center">Seguimiento de Notas por Cotización</h3>

          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>

          <Row>
            <Col md={2}>
              <Label>Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                onChange={(e) => setSelectedFechaInicio(e.target.value)}
              />
            </Col>
            <Col md={2}>
              <Label>Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                onChange={(e) => setSelectedFechaFin(e.target.value)}
              />
            </Col>
            <Col md={2}>
              <Label>Con notas</Label>
              <Input
                bsSize="sm"
                type="select"
                value={soloConNotas}
                onChange={(e) => {
                  setSoloConNotas(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="">Todos</option>
                <option value="Si">Solo con notas</option>
                <option value="No">Sin notas</option>
              </Input>
            </Col>
          </Row>
          <br />

          {vista === "calendario" ? (
            <Row>
              <Col md={5}>
                <Calendar
                  value={fechaCal}
                  onChange={setFechaCal}
                  tileClassName={({ date, view }) => {
                    if (view !== "month") return null;
                    const key = moment(date).format("YYYY-MM-DD");
                    return notasPorFecha[key] ? "tiene-notas" : null;
                  }}
                  tileContent={({ date, view }) => {
                    if (view !== "month") return null;
                    const key = moment(date).format("YYYY-MM-DD");
                    const cant = notasPorFecha[key]?.length || 0;
                    if (cant === 0) return null;
                    return (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginTop: 2,
                        }}
                      >
                        <span
                          style={{
                            backgroundColor: "#dc3545",
                            color: "#fff",
                            fontSize: 10,
                            fontWeight: "bold",
                            borderRadius: 8,
                            padding: "0 5px",
                            lineHeight: "14px",
                            minWidth: 16,
                            textAlign: "center",
                            display: "inline-block",
                          }}
                        >
                          {cant}
                        </span>
                      </div>
                    );
                  }}
                />
                <style>{`
                  .tiene-notas { background: #fff2b2 !important; }
                  .react-calendar { border: 1px solid #dee2e6; border-radius: 6px; padding: 6px; width: 100%; }
                  .react-calendar__tile { padding: 8px 4px; }
                  .react-calendar__tile--active { background: #007bff !important; color: white !important; }
                `}</style>
              </Col>
              <Col md={7}>
                <h5 className="mb-3">
                  Notas del {moment(fechaCal).format("DD [de] MMMM YYYY")}
                </h5>
                {notasDelDia.length === 0 ? (
                  <div
                    style={{
                      padding: 16,
                      backgroundColor: "#f8f9fa",
                      borderRadius: 4,
                      border: "1px solid #dee2e6",
                    }}
                  >
                    <em style={{ color: "#888" }}>
                      Sin notas capturadas en esta fecha.
                    </em>
                  </div>
                ) : (
                  <div style={{ maxHeight: 500, overflowY: "auto" }}>
                    {notasDelDia.map(({ pedido, nota }, idx) => (
                      <div
                        key={idx}
                        style={{
                          borderLeft: "3px solid #007bff",
                          padding: "10px 14px",
                          marginBottom: 10,
                          backgroundColor: "#f8f9fa",
                          borderRadius: 4,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            fontSize: 12,
                            color: "#666",
                            marginBottom: 6,
                          }}
                        >
                          <span>
                            <strong>Cotización #{pedido.numero}</strong>
                            {" · "}
                            {pedido.clientes}
                            {" · "}
                            {pedido.vendedor}
                          </span>
                          <span>
                            <em>{nota.userName || "Usuario"}</em>
                          </span>
                        </div>
                        <div style={{ whiteSpace: "pre-wrap" }}>
                          {nota.texto}
                        </div>
                        <div className="mt-2">
                          <Button
                            size="sm"
                            color="warning"
                            onClick={() => abrirModalNota(pedido)}
                            title="Ver/agregar notas"
                          >
                            <i className="far fa-sticky-note"></i> Notas
                          </Button>{" "}
                          <Button
                            size="sm"
                            color="danger"
                            onClick={() => descargarPDF(pedido)}
                            title="Descargar PDF con seguimiento"
                          >
                            <i className="far fa-file-pdf"></i> PDF
                          </Button>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </Col>
            </Row>
          ) : (
          <>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => (
                <tr key={a._id}>
                  <td>{a.numero}</td>
                  <td>{a.fecha}</td>
                  <td>{a.clientes}</td>
                  <td>{a.vendedor}</td>
                  <td align="right">
                    {new Intl.NumberFormat("en-US", {
                      style: "currency",
                      currency: "USD",
                      maximumFractionDigits: 2,
                    }).format(a.total_general || 0)}
                  </td>
                  <td>{a.ultimaFechaNota || <em style={{ color: "#888" }}>—</em>}</td>
                  <td style={{ maxWidth: 320, whiteSpace: "pre-wrap" }}>
                    {a.ultimoTextoNota ? (
                      <>
                        {a.ultimoTextoNota}
                        <br />
                        <small className="text-muted">
                          por {a.ultimoUsuarioNota}
                          {a.cantidadNotas > 1 ? ` · ${a.cantidadNotas} notas totales` : ""}
                        </small>
                      </>
                    ) : (
                      <em style={{ color: "#888" }}>Sin notas capturadas</em>
                    )}
                  </td>
                  <td>
                    <Button
                      size="sm"
                      color="danger"
                      onClick={() => descargarPDF(a)}
                      title="Descargar PDF con seguimiento"
                    >
                      <i class="far fa-file-pdf"></i>
                    </Button>{" "}
                    <Button
                      size="sm"
                      color={a.cantidadNotas > 0 ? "warning" : "secondary"}
                      onClick={() => abrirModalNota(a)}
                      title={
                        a.cantidadNotas > 0
                          ? `${a.cantidadNotas} nota(s)`
                          : "Agregar nota"
                      }
                    >
                      <i class="far fa-sticky-note"></i>
                      {a.cantidadNotas > 0 ? ` ${a.cantidadNotas}` : ""}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
          </>
          )}
        </div>
      ) : undefined}

      {/* Modal de notas: historial + agregar nueva */}
      <Modal size="lg" isOpen={modalNota} toggle={toggleNota}>
        <ModalHeader toggle={toggleNota}>
          Notas de la Cotización #{notaNumeroPedido}
        </ModalHeader>
        <ModalBody>
          <Label className="font-weight-bold">Historial</Label>
          {notasList.length === 0 ? (
            <div
              style={{
                padding: 10,
                backgroundColor: "#f8f9fa",
                borderRadius: 4,
                border: "1px solid #dee2e6",
              }}
            >
              <em style={{ color: "#888" }}>Sin notas capturadas</em>
            </div>
          ) : (
            <div style={{ maxHeight: 300, overflowY: "auto" }}>
              {notasList
                .slice()
                .sort((a, b) => (a.fecha < b.fecha ? 1 : -1))
                .map((n, idx) => (
                  <div
                    key={n._id || idx}
                    style={{
                      borderLeft: "3px solid #007bff",
                      padding: "8px 12px",
                      marginBottom: 8,
                      backgroundColor: "#f8f9fa",
                      borderRadius: 4,
                    }}
                  >
                    <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                      <strong>{n.userName || "Usuario"}</strong>
                      {" · "}
                      {n.fecha || ""}
                    </div>
                    <div style={{ whiteSpace: "pre-wrap" }}>{n.texto}</div>
                  </div>
                ))}
            </div>
          )}

          <hr />

          <Label className="font-weight-bold">Agregar nueva nota</Label>
          <Row>
            <Col md={4}>
              <Label className="small">Fecha</Label>
              <Input
                type="date"
                value={nuevaNotaFecha}
                onChange={(e) => setNuevaNotaFecha(e.target.value)}
              />
            </Col>
          </Row>
          <br />
          <Input
            type="textarea"
            rows="4"
            value={nuevaNotaTexto}
            onChange={(e) => setNuevaNotaTexto(e.target.value)}
            placeholder="Escribe la nota relacionada a esta cotización..."
          />
          <small className="text-muted">
            Se guardará con tu nombre y la fecha seleccionada.
          </small>
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            onClick={agregarNota}
            disabled={!nuevaNotaTexto.trim()}
          >
            Agregar nota
          </Button>
          <Button color="secondary" onClick={toggleNota}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default SeguimientoNotas;
